var map = {
	"./article-1-flat.jpg": "RXCM",
	"./article-2-flat.jpg": "PMTP",
	"./article-3-flat.jpg": "GZIa",
	"./article-4-flat.jpg": "sfY5",
	"./article-5-flat.jpg": "prVR",
	"./article_1/portrait/background.jpg": "0WpJ",
	"./article_1/portrait/copy.png": "I3uq",
	"./article_1/portrait/number-copy.png": "040t",
	"./article_1/portrait/overlays.png": "9EWO",
	"./article_1/portrait/portrait.png": "ye2Q",
	"./article_1/stage_quotes/stage_quote_cress.jpg": "/FTD",
	"./article_1/stage_quotes/stage_quote_draisin.jpg": "x15+",
	"./article_1/stage_quotes/stage_quote_edelman.jpg": "b7S9",
	"./article_2/portrait/background.jpg": "rjmg",
	"./article_2/portrait/copy.png": "1FRq",
	"./article_2/portrait/number-copy.png": "4yXg",
	"./article_2/portrait/overlays.png": "nfG3",
	"./article_2/portrait/portrait.png": "+Hm2",
	"./article_2/stage_quotes/stage_quote_benedik.jpg": "RH+5",
	"./article_2/stage_quotes/stage_quote_bennett.jpg": "icc2",
	"./article_2/stage_quotes/stage_quote_cress.jpg": "oYYv",
	"./article_2/stage_quotes/stage_quote_draisin.jpg": "BkJH",
	"./article_2/stage_quotes/stage_quote_rayer.jpg": "3hHC",
	"./article_3/portrait/background.jpg": "nK+X",
	"./article_3/portrait/copy.png": "/MB7",
	"./article_3/portrait/number-copy.png": "2HOc",
	"./article_3/portrait/overlays.png": "IY4b",
	"./article_3/portrait/portrait.png": "PhDv",
	"./article_3/stage_quotes/stage_quote_bala.jpg": "oni7",
	"./article_3/stage_quotes/stage_quote_bennett.jpg": "vuN0",
	"./article_3/stage_quotes/stage_quote_cress.jpg": "bA9P",
	"./article_3/stage_quotes/stage_quote_draisin.jpg": "TSLu",
	"./article_3/stage_quotes/stage_quote_flynn.jpg": "3SqJ",
	"./article_4/portrait/background.jpg": "BZjt",
	"./article_4/portrait/copy.png": "mR3v",
	"./article_4/portrait/number-copy.png": "1oZk",
	"./article_4/portrait/overlays.png": "pIFx",
	"./article_4/portrait/portrait.png": "9uf7",
	"./article_4/stage_quotes/stage_quote_draisin.jpg": "JPvR",
	"./article_4/stage_quotes/stage_quote_edelman.jpg": "QDmn",
	"./article_4/stage_quotes/stage_quote_flynn.jpg": "hZOW",
	"./article_5/portrait/background.jpg": "/BI+",
	"./article_5/portrait/copy.png": "PkGm",
	"./article_5/portrait/number-copy.png": "eoR1",
	"./article_5/portrait/overlays.png": "myjj",
	"./article_5/portrait/portrait.png": "MwdD",
	"./article_5/stage_quotes/stage_quote_andresen.jpg": "iI0p",
	"./article_5/stage_quotes/stage_quote_bala.jpg": "sErm",
	"./article_5/stage_quotes/stage_quote_benedik.jpg": "926v",
	"./article_5/stage_quotes/stage_quote_bennett.jpg": "bhj/",
	"./article_5/stage_quotes/stage_quote_flynn.jpg": "fOIZ",
	"./carat.svg": "dUdN",
	"./diamond-blue.png": "y85g",
	"./diamond-green.png": "a6Sg",
	"./diamond-orange.png": "7hDF",
	"./diamond-purple.png": "lhhR",
	"./diamond-red.png": "1GTK",
	"./intro_video_cover.jpg": "i4ax",
	"./logos/adobe-logo-tab.png": "0FDv",
	"./logos/adobe.svg": "YCA1",
	"./logos/conde-nast-white.svg": "LN9F",
	"./logos/conde-nast.svg": "t7N1",
	"./logos/dow-jones-white.svg": "NnZ/",
	"./logos/dow-jones.svg": "dlhv",
	"./logos/edelman-white.svg": "S/Xj",
	"./logos/edelman.svg": "DSO0",
	"./logos/nat-geo-white.svg": "eYHE",
	"./logos/nat-geo.svg": "Kg5H",
	"./logos/nbc-universal-white.svg": "M1MC",
	"./logos/nbc-universal.svg": "xRog",
	"./logos/revolt-white.svg": "7fM3",
	"./logos/revolt.svg": "0fDh",
	"./logos/spotify-white.svg": "INxt",
	"./logos/spotify.svg": "FLp1",
	"./logos/usa-today-white.svg": "xOLk",
	"./logos/usa-today.svg": "3ShR",
	"./logos/wired-white.svg": "6ZPc",
	"./logos/wired.svg": "AN/l",
	"./sound-bar-still-dark.png": "GrnV",
	"./sound-bar-still.png": "3rLH",
	"./sound-bar.gif": "KCcG",
	"./square-background.jpg": "vc9v",
	"./video-placeholder.jpg": "8Qd/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1